import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_X: GlameraIconDefinition = {
  name: 'x',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-x-line" pathLength="1" d="M18 6 6 18"></path>
    <path class="glm-x-line glm-x-line-2" pathLength="1" d="m6 6 12 12"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-x-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './x.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class XIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_X;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
